<template>
	<div>
		<h3 class="mb-3">
			{{ $t('components.authentification.connexion.withMce') }}
		</h3>
		<span>
			{{ $t('components.authentification.connexion.withMceSubtitle') }}
		</span>
		<iframe
			v-if="htmlContent"
			:srcdoc="htmlContent"
			width="100%"
			height="600px"
		/>
		<VForm
			ref="form"
			class="mt-6"
			method="POST"
			:action="QRP_MCE_MAG_AUTH_URL"
		>
			<VTextField
				v-model="siret"
				v-facade="fieldRules.siret.mask"
				:label="$t('components.authentification.connexionMce.siret')"
				class="vd-form-input-xl mb-2"
				:rules="fieldRules.siret.rules"
				:counter="fieldRules.siret.counter"
				:counter-value="noSpacesCounter"
				outlined
				validate-on-blur
				name="siret"
			/>
			<div class="d-flex">
				<VTextField
					v-model="nom"
					name="nom"
					class="mr-6"
					:label="$t('components.authentification.connexionMce.nom')"
					:rules="[required]"
					outlined
				/>
				<VTextField
					v-model="prenom"
					name="prenom"
					:label="$t('components.authentification.connexionMce.prenom')"
					:rules="[required]"
					outlined
				/>
			</div>
			<VTextField
				v-model="password"
				name="password"
				:append-icon="showPassword ? eyeIcon : eyeOffIcon"
				:type="showPassword ? 'text' : 'password'"
				:label="$t('components.authentification.connexionMce.password')"
				outlined
				:rules="[required]"
				@click:append="showPassword = !showPassword"
				@keydown.enter.prevent="seConnecter"
			/>
			<input
				type="hidden"
				name="urlKO"
				:value="QRP_MCE_MAG_URL_KO"
			>
			<input
				type="hidden"
				name="urlOK"
				:value="QRP_MCE_MAG_URL_OK"
			>
			<input
				type="hidden"
				name="nomJeton"
				value="jtd"
			>
			<input
				type="hidden"
				name="parametreUrl"
				value="jtd="
			>
			<VBtn
				class="vd-form-input-xl"
				color="primary"
				large
				:loading="state === StateEnum.PENDING"
				@click="submit"
			>
				{{ $t('components.authentification.connexion.seConnecter') }}
			</VBtn>
		</VForm>
	</div>
</template>

<script lang="ts">
	import Vue from 'vue';
	import Component from 'vue-class-component';
	import { Refs } from '@cnamts/vue-dot/src/types';
	import { FormRef } from '@/types';
	import { required } from '@cnamts/vue-dot/src/rules/required';
	import { mdiEye, mdiEyeOff } from '@mdi/js';
	import { StateEnum } from '@cnamts/vue-dot/src/constants/enums/StateEnum';
	import { exactLength } from '@cnamts/vue-dot/src/rules/exactLength';
	import { SIRET_LENGTH } from '@/constants/siret';
	import { noSpacesCounter } from '@/functions/noSpaceCounter';
	import { NOTIFICATION_PATH } from '@/constants/uri';
	import { ERROR_CODES } from '@/constants/mceAuthErrorCodes';

	declare const QRP_MCE_MAG_URL_OK: string;
	declare const QRP_MCE_MAG_URL_KO: string;
	declare const QRP_MCE_MAG_AUTH_URL: string;

	@Component
	export default class ConnexionMCE extends Vue {
		$refs!: Refs<{
			form: FormRef;
		}>;
		siret = '';
		nom = '';
		prenom = '';
		password = '';
		showPassword = false;
		required = required;
		eyeIcon = mdiEye;
		eyeOffIcon = mdiEyeOff;
		noSpacesCounter = noSpacesCounter;
		StateEnum = StateEnum;
		state: StateEnum = StateEnum.IDLE;
		htmlContent = '';
		fieldRules = {
			siret: {
				rules: [
					required,
					exactLength(SIRET_LENGTH, true)
				],
				mask: '##############',
				counter: SIRET_LENGTH
			}
		};
		QRP_MCE_MAG_URL_OK = QRP_MCE_MAG_URL_OK;
		QRP_MCE_MAG_URL_KO = QRP_MCE_MAG_URL_KO;
		QRP_MCE_MAG_AUTH_URL = QRP_MCE_MAG_AUTH_URL;

		mounted(): void {

			const errorCode: string = this.$route.query.errorCode as string;

			if (errorCode) {
				this.$store.dispatch(NOTIFICATION_PATH, {
					type: 'error',
					message: `Erreur ${ERROR_CODES[errorCode].code} : ${ERROR_CODES[errorCode].description}`
				});
				return;
			}
		}

		submit(): void {
			if (this.$refs.form.validate()) {
				this.siret = this.siret.replace(/\s/g, '');
				this.$refs.form.$el.submit();
			}
		}
	}
</script>

<style scoped lang="scss">
:deep(.v-text-field--outlined > .v-input__control > .v-input__slot) {
	background-color: white;
}

.bg-white{
	background-color: white;
}
</style>
